import axios from "axios";
import { EventFilterRequest, EventResponse, EventResponseDto, RadiusSearchRequest } from "./Dtos/EventsDtos";

// Following the existing service pattern in the codebase
export const EventsService = {
  events: {
    /**
     * Filter events based on provided criteria
     * @param filters - Event filter parameters
     * @returns Promise with event response data
     */
    filter: async (filters: EventFilterRequest): Promise<EventResponse> => {
      const response = await axios.post<EventResponseDto[]>(
        "/api/v1/events/filter",
        filters,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // API returns an array directly, so wrap it in the expected format
      return {
        success: true,
        data: response.data,
      };
    },

    /**
     * Search for events within a radius of a given lat/lng
     * @param params - Radius search parameters (lat, lng, radius)
     * @returns Promise with event response data
     */
    nearby: async (params: RadiusSearchRequest): Promise<EventResponse> => {
      const response = await axios.get<EventResponseDto[]>(
        "/api/v1/events/nearby",
        {
          params: {
            lat: params.lat,
            lng: params.lng,
            radius: params.radius || 10.0,
          },
        }
      );
      // API returns an array directly, so wrap it in the expected format
      return {
        success: true,
        data: response.data,
      };
    },
  },
};
